import { useIsMaterialCalloutsEnabled } from '../../hooks/split';

import { useCustomization } from './useCustomization';

export const useCustomizationMaterialCallout = () => {
  const isMaterialCalloutsEnabled = useIsMaterialCalloutsEnabled();
  const { history } = useCustomization();

  if (!isMaterialCalloutsEnabled) return undefined;

  const product = history.entries[history.activeIndex].customization?.product;

  return product && 'productCatalogVariationUuid' in product
    ? product.manufacturerUrl
    : undefined;
};
